<div class="page-wraper">
  <div class="page-content">
    <!-- <app-section-page-banner [data]="banner"></app-section-page-banner> -->

    <div class="section-full p-tb80 column-grid-4 inner-page-padding">
      <div class="container">
        @if (selectedCategory) {
        <div class="portfolio-intro text-center m-b50">
          <div class="section-head text-center">
            <div class="sx-separator-outer separator-center">
              <div class="sx-separator">
                <h3 class="sep-line-one">{{ selectedCategory.name }}</h3>
              </div>
            </div>
          </div>
          <ul class="social-icons sx-social-links d-flex justify-content-center portfolio-social-links">
            @if (selectedCategory.facebook) {
              <li class="pr-2"><a [href]="selectedCategory.facebook" target="_blank" rel="noopener" aria-label="Facebook" class="fa fa-facebook"></a></li>
            }
            @if (selectedCategory.instagram) {
              <li class="pr-2"><a [href]="selectedCategory.instagram" target="_blank" rel="noopener" aria-label="Instagram" class="fa fa-instagram"></a></li>
            }
            @if (selectedCategory.youtube) {
              <li><a [href]="selectedCategory.youtube" target="_blank" rel="noopener" aria-label="YouTube" class="fa fa-youtube"></a></li>
            }
          </ul>
          <p class="portfolio-description">
            {{ selectedCategory.description }}
          </p>
        </div>
        }

        <div class="portfolio-categories m-b50">
          <a routerLink="/photography" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">All</a>
          @for (category of categories; track category.slug) {
          <a [routerLink]="['/photography', category.slug]" routerLinkActive="active">
            {{ category.shortName }}
          </a>
          }
        </div>

        @if (!selectedCategory) {
        <div class="photography-category-cards m-b60">
          @for (category of categories; track category.slug) {
          <a class="category-card" [class.category-card-coming-soon]="!category.available"
            [routerLink]="['/photography', category.slug]">
            @if (category.available) {
            <div class="category-card-image">
              <img [src]="category.coverImage" [alt]="category.name" width="900" height="1200" loading="lazy"
                decoding="async" />
              <div class="category-card-overlay"></div>
            </div>
            } @else {
            <div class="category-card-image category-card-placeholder">
              <div class="category-card-placeholder-inner">
                <span>Vishwas Fotography</span>
                <strong>Coming Soon</strong>
              </div>
            </div>
            }
            <div class="category-card-content">
              <span>{{ category.available ? 'Explore the work' : 'New category' }}</span>
              <h3>{{ category.name }}</h3>
              @if (category.available) {
              <p class="category-card-description">{{ category.description }}</p>
              }
            </div>
          </a>
          }
        </div>
        }

        @if (selectedCategory && !selectedCategory.available) {
        <div class="coming-soon text-center p-t50 p-b50">
          <h3>{{ selectedCategory.name }}</h3>
          <p>This portfolio is being prepared. More work will be added soon.</p>
          <a routerLink="/photography" class="site-button">Back to Photography</a>
        </div>
        } @else {
        <ul class="mfp-gallery work-grid list-unstyled">
          @for (object of filteredPortfolios; track object.image) {
          <li class="portfolio-grid-item">
            <app-elements-box6 [data]="object" gap="0"></app-elements-box6>
          </li>
          }
        </ul>
        }

        <div class="text-center load-more-btn-outer"
          style="background-image:url(assets/images/background/cross-line.png)">
          <a target="_blank" rel="noreferrer"
            [href]="selectedCategory?.instagram || 'https://www.instagram.com/vishwasfotography/'"
            class="site-button-secondry btn-half">
            <span>Follow on Instagram</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>